module.exports = __webpack_public_path__ + "static/requinte-basico-06618605873cdfed5dd649b8a02d8af0.svg";